<template>
  <section v-if="featured.length > 0" class="q-featured-section">
    <div class="container">
      <p class="q-section-title">Productos destacados</p>
      <Splide :options="splideOptions">
        <SplideSlide v-for="product in featured" :key="product.id" class="q-featured-slide">
          <ProductCard :product="product" />
        </SplideSlide>
      </Splide>
    </div>
  </section>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import ProductCard from "./Product-card";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { Splide, SplideSlide, ProductCard },

  created() { this.loadFeatured(); },

  computed: {
    ...mapGetters({ featured: "ecommerce/featured" }),
  },

  methods: {
    ...mapActions({ loadFeatured: "ecommerce/loadFeatured" }),
  },

  data() {
    return {
      splideOptions: {
        type:       "loop",
        perPage:    4,
        perMove:    1,
        gap:        "1rem",
        autoplay:   true,
        interval:   3500,
        pauseOnHover: true,
        arrows:     true,
        pagination: true,
        breakpoints: {
          1200: { perPage: 3 },
          992:  { perPage: 2 },
          576:  { perPage: 1 },
        },
      },
    };
  },
};
</script>

<style>
/* Splide theme overrides — dark */
.q-featured-section .splide__arrow {
  background: var(--q-bg-elevated);
  border: 1px solid var(--q-border);
  opacity: 1;
  width: 36px; height: 36px;
  transition: all var(--q-transition);
}
.q-featured-section .splide__arrow:hover {
  background: var(--primary-color);
  border-color: var(--primary-color);
}
.q-featured-section .splide__arrow svg { fill: var(--q-text); }
.q-featured-section .splide__arrow:hover svg { fill: #ffffff; }

.q-featured-section .splide__pagination__page {
  background: var(--q-text-subtle);
  width: 6px; height: 6px;
  transition: background var(--q-transition), transform var(--q-transition);
}
.q-featured-section .splide__pagination__page.is-active {
  background: var(--primary-color);
  transform: scale(1.4);
}

.q-featured-slide { padding: 4px; }
</style>

<style scoped>
.q-featured-section {
  padding: 40px 0;
  border-top: 1px solid var(--q-border);
}
</style>
